// extracted by mini-css-extract-plugin
export default {"generalLink":"GeneralLinkLarge_generalLink__cQh7C"};